var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.confirmed || !_vm.user)?_c('div',[_c('authentication',{ref:"auth"})],1):_c('div',[_c('dashboard')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }